module.exports = __webpack_public_path__ + "media/images/logoicon-9a5419aeae0c35f6e3e32e6f032d07b3.png";